export default "__VITE_ASSET__uplxOhf3__"